import { render, staticRenderFns } from "./navxsgj.vue?vue&type=template&id=045baf1c&scoped=true&"
import script from "./navxsgj.vue?vue&type=script&lang=js&"
export * from "./navxsgj.vue?vue&type=script&lang=js&"
import style0 from "./navxsgj.vue?vue&type=style&index=0&id=045baf1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045baf1c",
  null
  
)

export default component.exports